import Vue from 'vue'

import Analytics from '@siteminder/analytics'
import { router } from '@/router'
import config from '@/config'

Vue.use(Analytics, {
  uaId: config.UA_ID,
  router,
})
